import React from "react";
import {
  Button,
  Dialog as MUIDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import { TextFourteenBlack } from "../../../css components/Style";

export default function ConfirmPopUp({
  formikProps,
  dialogState,
  setDialogState,
}) {
  const handleClose = () => {
    setDialogState({ ...dialogState, state: false });
  };

  return (
    <React.Fragment>
      <MUIDialog open={dialogState.state} onClose={handleClose}>
        <DialogTitle style={{ paddingBottom: "0px" }}></DialogTitle>
        <DialogContent>
          <DialogContentText>
            <TextFourteenBlack>
              Are you sure you want to {dialogState?.data?.content}?
            </TextFourteenBlack>
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ padding: "0px 24px 16px" }}>
          <Button onClick={handleConfirm} variant="contained" autoFocus>
            Confirm
          </Button>

          <Button onClick={handleClose} variant="outlined" autoFocus>
            Cancel
          </Button>
        </DialogActions>
      </MUIDialog>
    </React.Fragment>
  );

  async function handleConfirm() {
    await dialogState?.data?.handleFunction();
    handleClose();
  }
}
